import { render, staticRenderFns } from "./YanChuOrder.vue?vue&type=template&id=b60571fe&scoped=true&"
import script from "./YanChuOrder.vue?vue&type=script&lang=js&"
export * from "./YanChuOrder.vue?vue&type=script&lang=js&"
import style0 from "./YanChuOrder.vue?vue&type=style&index=0&id=b60571fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60571fe",
  null
  
)

export default component.exports